import { useState } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'

export const Input = ({ props, name, placeholder, type ="" }) => {
    
    const [isHidden, setIsHidden] = useState(true);

    const toggleVisibility = ()=> {
        setIsHidden((prevState) => {
            if(prevState){
                return false;
            }
            else 
            {
                return true;
            }

        })
    }

    return (
        <>
            {type == "password" && 
                <div className="input-container">
                <input {...props}  type={isHidden ? "password" : "text"} value={props.value} onChange={props.onChange} />
                <label className={props.value && 'filled'} htmlFor={name}>
                    {placeholder}
                </label>
                <FontAwesomeIcon onClick={toggleVisibility} icon={isHidden ? faEyeSlash: faEye} style={{color:"black", position:"absolute",bottom:40, right:30, height:30}} />
            </div>
            }
            
            {type !== "password" && 
                <div className="input-container">
                <input {...props}  value={props.value} onChange={props.onChange} />
                <label className={props.value && 'filled'} htmlFor={name}>
                    {placeholder}
                </label>
            </div>
            }
        </>
    )
}

